// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

class PostTileVerTextSmall extends React.Component {
	render() {
		const { url, title, author, date } = this.props

		return (
			<Link className="post-tile is-vertical is-small without-image" to={ url }>
				<div className="-text">
					<h3 className="-title">{ title }</h3>

					<div className="-author-date">
						<div className="-author">{ author }</div>
						<div className="-date">{ date }</div>
					</div>
				</div>
			</Link>
		)
	}
}

export default PostTileVerTextSmall
